<template>
  <v-container fluid="fluid" grid-list-md="grid-list-md">
    <router-view></router-view>
  </v-container>
</template>
<script>

export default {
  name: 'adImage',
  data() {
    return {}
  },
}
</script>
